import React from 'react';
import { connect } from 'react-redux';
import PassageTextFeedback from '../../utils/feedback/passageTextFeedback';

const mapStateToProps = (state) => {
	const {
		answerCount,
		rightFeedbackProps,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		answerCount,
		rightFeedbackProps,
		leftFeedbackProps,
	};
};

const WordCloudIncorrectFeedback = ({
	answerCount,
	rightFeedbackProps: {
		textCorrectAnswer,
		correctAnswer,
		userAnswer,
		passage,
		defaultFeedback,
		score,
	},
	leftFeedbackProps: { question, qtype, selectedAnswer },
}) => {
	textCorrectAnswer = !!textCorrectAnswer ? textCorrectAnswer : correctAnswer;
	return (
		<span>
			<h4 className="text-danger">That's incorrect</h4>

			<div className="quiz-area-answer">
				<div className="display-flex align-center">
					<div className="bord-right col-md-3">
						<h4 className="text-danger text-right">Your answer</h4>
					</div>

					<PassageTextFeedback
						passage={passage}
						correctAnswer={textCorrectAnswer}
						selectedAnswer={selectedAnswer}
					/>
				</div>
				<div className="display-flex align-center">
					<div className="bord-right col-md-3">
						<h4 className="text-success text-right">Correct answer</h4>
					</div>
					<div>
						<PassageTextFeedback
							passage={passage}
							correctAnswer={textCorrectAnswer}
							selectedAnswer={textCorrectAnswer}
						/>
					</div>
				</div>
			</div>
		</span>
	);
};

export default connect(mapStateToProps)(WordCloudIncorrectFeedback);
